import { useTranslation } from 'react-i18next';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { useAppSelector } from '../../../../reduxService/hooks';
import { EProjectType } from '../../../enum/project';
import { selectProjectInfo } from '../../../store/projectInfo/projectInfoSlice';
import { EErrorBreadcrumb, getErrorBreadcrumb } from '../../../utils/utils';
import { selectProject, selectResults } from '../../selector/conversion';
import BasinDesignResults from './BasinDesignResults/BasinDesignResults';
import './GraphicalResults.scss';
import HydraulicResults from './HydraulicResults/HydraulicResults';
import StaticResults from './StaticResults/StaticResults';
import StressResults from './StressResults/StressResults';
import CrossSection from './crossSection/CrossSection';

const GraphicalResults = () => {
    const { t } = useTranslation();

    const results = useAppSelector(selectResults);
    const projectInfo = useAppSelector(selectProjectInfo);

    const error = getErrorBreadcrumb();

    return (
        <Tabs id='GraphicalResults'>
            <TabPanel>
                <CrossSection />
            </TabPanel>
            {!results.initialState && (
                <>
                    <TabPanel>
                        <HydraulicResults />
                    </TabPanel>

                    <TabPanel>
                        <BasinDesignResults />
                    </TabPanel>
                    {projectInfo.data?.type === (EProjectType.Macra2 | EProjectType.VerticalDrop) && (
                        <TabPanel>
                            <StaticResults />
                        </TabPanel>
                    )}
                    {projectInfo.data?.type === (EProjectType.Macra2 | EProjectType.SlopedWeir) && (
                        <TabPanel>
                            <StressResults />
                        </TabPanel>
                    )}
                </>
            )}
            <TabList>
                <Tab>{t('graphical_results_cross_section')}</Tab>
                {!results.initialState && (
                    <>
                        <Tab style={error.type & EErrorBreadcrumb.Macra2_Hydraulic ? { backgroundColor: '#b91023', color: 'white' } : { backgroundColor: '#004652', color: 'white' }}>
                            {t('graphical_results_hydraulic')}
                        </Tab>
                        <Tab style={error.type & EErrorBreadcrumb.Macra2_Basin ? { backgroundColor: '#b91023', color: 'white' } : { backgroundColor: '#004652', color: 'white' }}>
                            {t('graphical_results_basinDesign')}
                        </Tab>
                        {projectInfo.data?.type === (EProjectType.Macra2 | EProjectType.VerticalDrop) && (
                            <Tab style={error.type & EErrorBreadcrumb.Macra2_Static ? { backgroundColor: '#b91023', color: 'white' } : { backgroundColor: '#004652', color: 'white' }}>
                                {t('graphical_results_static')}
                            </Tab>
                        )}
                        {projectInfo.data?.type === (EProjectType.Macra2 | EProjectType.SlopedWeir) && <Tab style={{ backgroundColor: '#004652', color: 'white' }}>{t('stress')}</Tab>}
                    </>
                )}
            </TabList>
        </Tabs>
    );
};

export default GraphicalResults;
